import getExtensibilityState from '../store/getExtensibilityState';
import { getUiLessAddinInstanceFromControlId } from './uilessUtils';
import type IExtendedAddinCommand from '../store/schema/interfaces/IExtendedAddinCommand';
import type { ObservableMap } from 'mobx';
import { getTaskPaneRunningInstanceByControlId } from './taskPaneUtils';

/*
  Fetches the targetWindow corresponding to the controlId for UILess addins
  Should be used for read, as we can have multiple targetWindow for a hostItemIndex
 */
function getTargetWindowFromControlIdForUILess(controlId: string): Window {
    const addinInstanceFromControlId: string = getUiLessAddinInstanceFromControlId(controlId);

    let targetWindow: Window = window;
    const uilessAddins = getRunningUilessAddins();

    if (!addinInstanceFromControlId || !uilessAddins) {
        return targetWindow;
    }

    uilessAddins.forEach((addinCommandMap, addinInstanceString) => {
        if (addinInstanceString === addinInstanceFromControlId) {
            addinCommandMap.forEach((extendedAddinCommand, uiLessControlId) => {
                if (controlId == uiLessControlId) {
                    targetWindow = extendedAddinCommand.targetWindow;
                }
            });
        }
    });

    return targetWindow;
}

/*
  Fetches the targetWindow corresponding to the controlId for addins
  Checks both for both Taskpane as well as UILess addins
*/
export function getTargetWindowFromControlId(controlId: string): Window {
    const taskPaneInstance = getTaskPaneRunningInstanceByControlId(controlId);
    if (taskPaneInstance) {
        return taskPaneInstance.targetWindow;
    }
    return getTargetWindowFromControlIdForUILess(controlId);
}

/*
  Fetches the targetWindow corresponding to the hostItemIndex
  Should be used for compose, as we can have only one targetWindow for a hostItemIndex
 */
export function getTargetWindowFromHostItemIndex(hostItemIndex: string): Window {
    let targetWindow: Window = window;
    const uilessAddins = getRunningUilessAddins();

    if (!uilessAddins) {
        return targetWindow;
    }

    uilessAddins.forEach((addinCommandMap, addinInstanceString) => {
        const addinInstance = JSON.parse(addinInstanceString);
        if (addinInstance.hostItemIndex === hostItemIndex) {
            addinCommandMap.forEach((extendedAddinCommand, uiLessControlId) => {
                {
                    targetWindow = extendedAddinCommand.targetWindow;
                }
            });
        }
    });

    return targetWindow;
}

function getRunningUilessAddins(): ObservableMap<
    string /*key: hostItemIndex and tabId*/,
    ObservableMap<string /*key: controlId*/, IExtendedAddinCommand>
> {
    return getExtensibilityState().runningUILessExtendedAddinCommands;
}
